import { RootState } from 'Data/Redux';
import { createSelector } from 'reselect';
import * as oPath from 'Lib/Object/Path/Immutable';

export const createFirstWorksheetSelector = (path: string = '', _: boolean = true) =>
  createSelector(
    (state: RootState) => Object.values(state.worksheetGrid.worksheets)[0]?.syncModel,
    (worksheet) => oPath.get(worksheet, path)
  );
